<template>
    <div>
        <div v-if="$store.menu.length > 0" id="product_menu">
            <div class="MainContent">
                <ul class="ProductList">
                    <MenuIcon
                        v-for="option in $store.menu"
                        :key="option.name"
                        :option="option"
                        :selected="selected"
                        @click="handleClick"
                    />
                </ul>
            </div>
            <div v-if="selected.length > 0" class="product-list-arrow"></div>
            <IconMenu
                v-for="option in $store.menu"
                :key="option.name"
                :option="option"
                :selected="selected"
                @click="handleClick"
            />
            <div v-if="$store.showLoadingOverlay" id="divLoader"></div>

            <div class="clearer"></div>
        </div>

        <display-announcement
            v-for="announcement in announcements"
            :key="announcement.announcementId"
            :announcement="announcement"
            @blur="(val) => closePopup(val)"
            @input="(val) => closePopup(val, true)"
        />
    </div>
</template>

<script>
    import DisplayAnnouncement from '@/feature/announcements/DisplayAnnouncement';
    import { post, save } from '@/utils/Http';
    import IconMenu from './IconMenu';
    import MenuIcon from './MenuIcon';
    import './resources/styles/portalmenu.scss';

    export default {
        name: 'PortalMenu',
        components: {
            DisplayAnnouncement,
            IconMenu,
            MenuIcon,
        },
        data() {
            return {
                announcements: [],
                selected: [],
            };
        },
        created() {
            if (this.$store.lastMenuOption) {
                this.openMenu(this.$store.lastMenuOption);
            }

            this.loadAnnouncements();
        },
        methods: {
            closePopup(id, acknowledge = false) {
                this.announcements = this.announcements.filter((x) => x.announcementId !== id);
                if (acknowledge) {
                    save('announcements/acknowledge', { announcementId: id });
                }
            },

            handleClick(option) {
                if (option.products) {
                    this.openMenu(option.name);
                } else {
                    this.loading = true;
                    this.$store.navigate(option);
                }
            },

            isSelected(option, selected) {
                if (
                    (!!option.products && !!option.products.find((x) => this.isSelected(x, selected))) ||
                    option.name === selected
                ) {
                    if (option.products) {
                        this.selected.push(option.name);
                    }

                    return true;
                }

                return false;
            },

            loadAnnouncements() {
                post('announcements/getdisplay', {}, (response) => {
                    this.announcements = response.announcements;
                });
            },

            openMenu(selected) {
                this.selected = [];
                this.$store.menu.map((x) => this.isSelected(x, selected));
            },
        },
    };
</script>
